import { useQuery } from "@tanstack/react-query";
import type { IOverviewJointBillService } from "@services/overview/types";
import { getJointBillServiceSettings, getProjectData } from "./services";
import type { IJointBillServiceSettings, IProjectData } from "./types";

export const useJointBillServiceSettingsQuery = (
  jointBillServiceId: IOverviewJointBillService["jointBillServiceId"],
  enabled?: boolean,
) =>
  useQuery<IJointBillServiceSettings>({
    queryKey: ["jointBillServiceSettings", jointBillServiceId],
    queryFn: () => getJointBillServiceSettings({ jointBillServiceId }),
    enabled,
    staleTime: Infinity,
  });

export const useProjectDataQuery = (
  jointBillServiceId: IOverviewJointBillService["jointBillServiceId"],
) =>
  useQuery<IProjectData>({
    queryKey: ["jointBillServiceSettings", "projectData", jointBillServiceId],
    queryFn: () => getProjectData(jointBillServiceId),
    staleTime: Infinity,
  });
